export const ist = {
    IstProgressClass: {
        url: "SolarIst",
        defaultSegment: "SolarIst",
        forceRefresh: false,
        receiveType: 'RECEIVE_IstProgress_istReducer'
    },
    IstProgressYearClass: {
        url: "SolarIst",
        defaultSegment: "SolarIst",
        forceRefresh: false,
        receiveType: 'RECEIVE_IstProgressYear_istReducer'
    },
    BarDiagrammIstClass: {
        url: "Diagramm/hBar",
        defaultSegment: "Diagramm",
        forceRefresh: false,
        receiveType: 'RECEIVE_BarDiagrammIst_istReducer'
    }
};